<template>
  <div class="row raffle-campaigns">
    <div class="col-xl-12 col-md-12 col-xs-12">
      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">

          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>

          <div class="table-top" style="display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; flex-wrap: wrap; flex-direction: column;">
            <div class="left-group" style="display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-end; flex: 1 1 auto;">
              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <label>{{ $t('raffleCampaigns.id') }}</label>
                <el-input
                  v-model="idFilter"
                  :placeholder="$t('raffleCampaigns.id')"
                  size="small"
                  clearable
                  @keyup.enter.native="applyFilters"
                />
              </div>

              <div class="form-group" style="flex: 1 1 180px; margin: 0;">
                <label>{{ $t('raffleCampaigns.name') }}</label>
                <el-input
                  v-model="nameFilter"
                  :placeholder="$t('raffleCampaigns.search')"
                  size="small"
                  clearable
                  @keyup.enter.native="applyFilters"
                />
              </div>

              <div class="form-group" style="flex: 0 0 140px; margin: 0;">
                <label>{{ $t('raffleCampaigns.active') }}</label>
                <v-select
                  v-model="statusFilter"
                  :options="[
                    { id: 1, type: $t('general.active') },
                    { id: 0, type: $t('general.inactive') }
                  ]"
                  label="type"
                  :reduce="option => option.id"
                  :placeholder="$t('general.select')"
                  clearable
                ></v-select>
              </div>

              <div class="form-group" style="flex: 0 0 160px; margin: 0;">
                <label>{{ $t('raffleCampaigns.type') }}</label>
                <el-select
                  v-model="typeFilter"
                  clearable
                  size="small"
                  :placeholder="$t('general.select')"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="option in typeOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </div>

              <div class="form-group" style="flex: 0 0 240px; margin: 0;">
                <label>{{ $t('raffleCampaigns.startEnd') }}</label>
                <el-date-picker
                  type="daterange"
                  v-model="dateRangeFilter"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  size="small"
                  :placeholder="$t('raffleCampaigns.startEnd')"
                  style="width: 100%;"
                />
              </div>

              <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                <button class="btn add" @click="applyFilters" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                  <i class="ti-search"></i> {{ $t('general.search') }}
                </button>
              </div>
            </div>

            <div class="right-group" style="flex: 0 0 auto; margin-bottom: 20px; margin-top: 10px;">
              <router-link
                class="btn add"
                :title="$t('general.add') + ' ' + $t('raffleCampaigns.single')"
                :to="{ path: '/marketing/raffle-campaigns/add' }"
                style="font-size: 12px; padding: 4px 8px;"
              >
                <img src="/static/img/icons/icon-plus-sm.png" /> {{ $t('general.add') }}
              </router-link>
            </div>
          </div>

          <div class="data-table" style="margin-top: 20px;">
            <el-table
              :data="tableData"
              :row-class-name="rowClass"
              :empty-text="$t('gestiune.noData')"
              style="width: 100%;"
              @row-click="onRowClick">
              <el-table-column prop="id" :label="$t('raffleCampaigns.id')" width="80"/>
              <el-table-column prop="name" :label="$t('raffleCampaigns.name')" min-width="160" show-overflow-tooltip/>
              <el-table-column :label="$t('raffleCampaigns.type')" min-width="140">
                <template slot-scope="props">
                  {{ typeLabel(props.row.type) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('raffleCampaigns.startEnd')" min-width="200" class-name="date-range-cell">
                <template slot-scope="props">
                  {{ formatDate(props.row.starts_at) }} - {{ formatDate(props.row.ends_at) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('general.active')" width="100">
                <template slot-scope="scope">
                  <div @click.stop>
                    <p-switch
                      v-model="scope.row.active"
                      type="success"
                      @input="handleActive(scope.$index, scope.row, $event)"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('general.actions')" width="120">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" placement="bottom-end" @click.native.stop>
                    <span class="arrow-box">&#9662;</span>
                    <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                      <el-dropdown-item @click.native.stop="goToRecord(scope.row)">
                        {{ $t('general.edit') }}
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="scope.row.type === 'order_count'"
                        :disabled="exportingId === scope.row.id"
                        @click.native.stop="exportEntries(scope.row)">
                        {{ $t('raffleCampaigns.exportEntries') }}
                      </el-dropdown-item>
                      <el-dropdown-item @click.native.stop="handleDelete(scope.$index, scope.row)">
                        {{ $t('general.delete') }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination
              layout="prev, pager, next"
              :total="paginationDef.totalRecords"
              :page-size="paginationDef.perPage"
              :current-page.sync="paginationDef.page"
              @current-change="handlePageChange"
              style="margin-top: 15px; text-align: right;"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Input, Select, Option, DatePicker } from 'element-ui'
import PSwitch from 'src/components/UIComponents/Switch.vue'
import vSelect from 'vue-select'
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

Vue.component('v-select', vSelect)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)

export default {
  components: {
    PSwitch
  },
  props: {
    isRaffleCampaigns: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: true,
      idFilter: '',
      nameFilter: '',
      statusFilter: null,
      typeFilter: null,
      dateRangeFilter: [],
      tableData: [],
      exportingId: null,
      paginationDef: {
        page: 1,
        perPage: 25,
        totalRecords: 0
      }
    }
  },
  computed: {
    typeOptions () {
      return [
        { value: 'order_count', label: this.$t('raffleCampaigns.typeOrderCount') },
        { value: 'order_total', label: this.$t('raffleCampaigns.typeOrderTotal') }
      ]
    }
  },
  watch: {
    isRaffleCampaigns (active) {
      if (active) {
        this.getCampaigns()
      }
    }
  },
  created () {
    this.getCampaigns()
    this.$bus.$on('refresh', this.handleRefresh)
  },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    handleRefresh () {
      this.getCampaigns()
    },
    typeLabel (type) {
      if (type === 'order_total') {
        return this.$t('raffleCampaigns.typeOrderTotal')
      }
      return this.$t('raffleCampaigns.typeOrderCount')
    },
    onRowClick (row, column, event) {
      if (event.target.closest('.el-switch') || event.target.closest('.el-dropdown')) {
        return
      }
      this.goToRecord(row)
    },
    goToRecord (row) {
      this.$router.push({ path: '/marketing/raffle-campaigns/edit/' + row.id })
    },
    applyFilters () {
      this.paginationDef.page = 1
      this.getCampaigns()
    },
    handlePageChange (page) {
      this.paginationDef.page = page
      this.getCampaigns()
    },
    normalizeActiveFilterValue (value) {
      const rawValue = (value && typeof value === 'object' && 'id' in value) ? value.id : value
      if (rawValue === true || rawValue === 1 || rawValue === '1') return true
      if (rawValue === false || rawValue === 0 || rawValue === '0') return false
      return null
    },
    buildParams () {
      const params = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        page: this.paginationDef.page,
        per_page: this.paginationDef.perPage
      }
      const id = String(this.idFilter || '').trim()
      if (id !== '') {
        params.id = id
      }
      const name = String(this.nameFilter || '').trim()
      if (name !== '') {
        params.name = name
      }
      const active = this.normalizeActiveFilterValue(this.statusFilter)
      if (active !== null) {
        params.active = active
      }
      if (this.typeFilter) {
        params.type = this.typeFilter
      }
      if (this.dateRangeFilter && this.dateRangeFilter.length === 2 && this.dateRangeFilter[0] && this.dateRangeFilter[1]) {
        params.start_date = this.dateRangeFilter[0]
        params.end_date = this.dateRangeFilter[1]
      }
      return params
    },
    normalizeListResponse (response) {
      const payload = response.data || {}
      if (payload.pagination) {
        return {
          rows: payload.data || [],
          page: payload.pagination.page || this.paginationDef.page,
          perPage: payload.pagination.per_page || payload.pagination.perPage || this.paginationDef.perPage,
          total: payload.pagination.total || payload.pagination.totalRecords || 0
        }
      }
      if (response.pagination) {
        return {
          rows: Array.isArray(payload) ? payload : (payload.data || []),
          page: response.pagination.page || this.paginationDef.page,
          perPage: response.pagination.per_page || response.pagination.perPage || this.paginationDef.perPage,
          total: response.pagination.total || response.pagination.totalRecords || 0
        }
      }
      if (Array.isArray(payload)) {
        return { rows: payload, page: 1, perPage: this.paginationDef.perPage, total: payload.length }
      }
      if (Array.isArray(payload.data)) {
        return { rows: payload.data, page: 1, perPage: this.paginationDef.perPage, total: payload.data.length }
      }
      return { rows: [], page: 1, perPage: this.paginationDef.perPage, total: 0 }
    },
    getCampaigns () {
      this.loading = true
      this.apiRequest('/raffle-campaigns', 'GET', this.buildParams(), (response) => {
        if (response.status === true) {
          const normalized = this.normalizeListResponse(response)
          this.tableData = (normalized.rows || []).map(row => ({
            ...row,
            active: !!(parseInt(row.active) === 1 || row.active === true)
          }))
          this.paginationDef.page = normalized.page
          this.paginationDef.perPage = normalized.perPage
          this.paginationDef.totalRecords = normalized.total
        } else {
          this.tableData = []
          this.paginationDef.totalRecords = 0
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    rowClass ({ row }) {
      return row.active ? 'highlight-row' : ''
    },
    handleActive (index, row) {
      const actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
      swal({
        text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${row.name}?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then((result) => {
        if (result) {
          const data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            active: row.active ? 1 : 0
          }
          this.apiRequest('/raffle-campaigns/' + row.id, 'PUT', data, (response) => {
            if (response.status) {
              swal(this.$t('general.success') + '!', '', 'success').catch(() => {})
            } else {
              swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
              row.active = !row.active
            }
          })
        }
      }).catch(() => {
        row.active = !row.active
      })
    },
    handleDelete (index, row) {
      swal({
        text: this.$t('raffleCampaigns.areYouSureDelete') + ' ' + row.name + '?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('general.yes')
      }).then((result) => {
        if (result) {
          const data = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/raffle-campaigns/' + row.id, 'DELETE', data, (response) => {
            if (response.status === true) {
              swal('', this.$t('raffleCampaigns.campaignDeleted'), 'success').catch(() => {})
              this.tableData.splice(index, 1)
              this.paginationDef.totalRecords = Math.max(0, this.paginationDef.totalRecords - 1)
            } else {
              swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
            }
          })
        }
      }).catch(() => {})
    },
    exportEntries (row) {
      if (!row || row.id == null || row.type !== 'order_count' || this.exportingId != null) return
      this.exportingId = row.id
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/raffle-campaigns/' + row.id + '/export-entries', 'GET', data, (response) => {
        this.exportingId = null
        if (response.status === true && response.data && response.data.file) {
          const link = document.createElement('a')
          link.href = response.data.file
          link.setAttribute('download', response.data.file_name || ('raffle-campaign-' + row.id + '-entries.txt'))
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        } else {
          swal('', this.$t('validations.wentWrong'), 'error').catch(() => {})
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.raffle-campaigns .form-group {
  margin-bottom: 15px;
}
.tableInvoice .el-table .cell {
  word-break: break-word;
}
.tableInvoice .el-table .date-range-cell .cell {
  white-space: nowrap;
  word-break: normal;
}
.arrow-box {
  display: inline-block;
  font-size: 18px;
  padding: 4px 6px;
  border: 1px solid #674BD2 !important;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
  color: #674BD2;
}
.arrow-box:hover {
  background-color: #674BD2 !important;
  border-color: #674BD2 !important;
  color: #fff !important;
}
.custom-dropdown-menu {
  min-width: 180px;
  font-size: 14px;
}
.el-pagination {
  text-align: center !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/RaffleCampaigns/RaffleCampaigns.vue